import {
    ENABLE_ZOHO,
    transformPhase,
    TYPE_PHASES,
    ZOHO_CREATE_CUSTOMER_BASE_PATH,
    ZOHO_CUSTOMER_BASE_PATH,
    ZOHO_FILE_BASE_PATH,
    ZOHO_OPPORTUNITY_BASE_PATH,
    ZOHO_PHASE_BASE_PATH,
} from "../libs/zoho/constants";
import { EMPTY, Observable } from "rxjs";
import Api from "./api";
import { PhaseOne, PhaseOneParameters } from "../libs/zoho/models/PhaseOne";
import { PhaseTwoParameters } from "../libs/zoho/models/PhaseTwo";
import { PhaseThreeParameters } from "../libs/zoho/models/PhaseThree";
import { PhaseFourParamaters } from "../libs/zoho/models/PhaseFour";
import { map } from "rxjs/operators";
import {
    PhaseFileParameters,
    PhaseExtraFileParameters,
} from "../libs/zoho/models/PhaseFile";
import {
    PhaseCreateCustomer,
    PhaseGetCustomer,
} from "../libs/zoho/models/PhaseCustomer";

type ZohoOpportunityResponse = {
    zohoId: string;
};

export class ZohoApi {
    static URL_OPPORTUNITY = ZOHO_OPPORTUNITY_BASE_PATH;
    static URL_CUSTOMER = ZOHO_CUSTOMER_BASE_PATH;
    static URL_CREATE_CUSTOMER = ZOHO_CREATE_CUSTOMER_BASE_PATH;

    static URL_PHASE = ZOHO_PHASE_BASE_PATH;
    static URL_FILE = ZOHO_FILE_BASE_PATH;

    static getCustomer = (
        body: PhaseOneParameters,
        isEnabledZoho = ENABLE_ZOHO
    ): Observable<any> => {
        if (!isEnabledZoho) return EMPTY;
        const entity = new PhaseOne(body);

        return Api.get(
            `${ZohoApi.URL_CUSTOMER}/consulta?q=PersonDEO_tNumDoc_c=${entity.ruc};PersonDEO_chTipoDoc_c=2&onlyData=true`
        ).pipe(map((res) => res.response));
    };
    static createCustomer = (
        body: PhaseOneParameters,
        isEnabledZoho = ENABLE_ZOHO
    ): Observable<any> => {
        if (!isEnabledZoho) return EMPTY;
        const entity = new PhaseCreateCustomer(body);
        return Api.post(`${ZohoApi.URL_CREATE_CUSTOMER}/registra`, {
            entity: entity,
        }).pipe(
            map((res) => {
                return res.response;
            })
        );
    };
    static getOpportunity = (
        body: PhaseOneParameters,
        isEnabledZoho = ENABLE_ZOHO
    ): Observable<ZohoOpportunityResponse> => {
        if (!isEnabledZoho) return EMPTY;
        const entity = new PhaseGetCustomer(body);

        return Api.post(`${ZohoApi.URL_OPPORTUNITY}/opportunities`, {
            entity: entity,
        }).pipe(
            map((res) => {
                const obj = {
                    zohoId: res.response.OptyNumber,
                };
                return obj as ZohoOpportunityResponse;
            })
        );
    };

    static updatePhase = (
        phase: TYPE_PHASES,
        body:
            | PhaseTwoParameters
            | PhaseThreeParameters
            | PhaseFourParamaters
            | PhaseFileParameters
            | PhaseExtraFileParameters,
        isEnabledZoho = ENABLE_ZOHO
    ) => {
        if (!isEnabledZoho) return EMPTY;

        const entity = transformPhase(phase, body);

        if (phase === TYPE_PHASES.PHASE_FILE) {
            return Api.post(
                `${ZohoApi.URL_FILE}/opportunities/${body.zohoId}/child/Attachment`,
                {
                    entity: entity,
                    customHeader: {
                        ...Api.getPrivateHeader(),
                    },
                }
            );
        } else {
            return Api.patch(
                `${ZohoApi.URL_PHASE}/opportunities/${body.zohoId}`,
                {
                    entity: entity,
                    customHeader: {
                        ...Api.getPrivateHeader(),
                    },
                }
            );
        }
    };
}
